import { Icon } from '@chakra-ui/react';

export const TextQuestion = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M13.5185 3.3335H4.81481C4 3.3335 3.33333 4.00016 3.33333 4.81498V15.1853C3.33333 16.0002 4 16.6668 4.81481 16.6668H11.6667V15.1853H4.81481V4.81498H13.5185V10.0002H15V4.81498C15 4.00016 14.3333 3.3335 13.5185 3.3335Z"
      fill="currentColor"
    />
    <path
      d="M6.375 9.16683H10.2917C10.5908 9.16683 10.8333 9.40934 10.8333 9.7085C10.8333 10.0077 10.5908 10.2502 10.2917 10.2502H6.375C6.07584 10.2502 5.83333 10.0077 5.83333 9.7085C5.83333 9.40934 6.07584 9.16683 6.375 9.16683Z"
      fill="currentColor"
    />
    <path
      d="M8.625 6.79182H6.375C6.07584 6.79182 5.83333 7.03434 5.83333 7.33349C5.83333 7.63265 6.07584 7.87516 6.375 7.87516H8.625C8.92415 7.87516 9.16667 7.63265 9.16667 7.33349C9.16667 7.03434 8.92415 6.79182 8.625 6.79182Z"
      fill="currentColor"
    />
    <path
      d="M12.4167 11.6668C12.0025 11.6668 11.6667 12.0026 11.6667 12.4168C11.6667 12.831 12.0025 13.1668 12.4167 13.1668H13.5V15.9168C13.5 16.331 13.8358 16.6668 14.25 16.6668C14.6642 16.6668 15 16.331 15 15.9168V13.1668H15.9167C16.3309 13.1668 16.6667 12.831 16.6667 12.4168C16.6667 12.0026 16.3309 11.6668 15.9167 11.6668H12.4167Z"
      fill="currentColor"
    />
  </Icon>
);
